import { rtkapi } from './rtkapi';

const usageStatisticsApi = rtkapi.enhanceEndpoints({addTagTypes: ['UsageStatistics', 'Analytics']}).injectEndpoints({
    endpoints: (build) => ({
        // Analytics tracking endpoints
        trackPageView: build.mutation({
            query: (body) => ({ 
                url: '/analytics/page-view/', 
                method: 'POST', 
                data: body 
            }),
            invalidatesTags: ['UsageStatistics', 'Analytics']
        }),

        trackFeatureUsage: build.mutation({
            query: (body) => ({ 
                url: '/analytics/feature-usage/', 
                method: 'POST', 
                data: body 
            }),
            invalidatesTags: ['UsageStatistics', 'Analytics']
        }),

        trackSearchQuery: build.mutation({
            query: (body) => ({ 
                url: '/analytics/search/', 
                method: 'POST', 
                data: body 
            }),
            invalidatesTags: ['UsageStatistics', 'Analytics']
        }),

        // Statistics retrieval endpoints
        getUsageStatistics: build.query({
            query: (params) => ({ url: '/stats/usage/', method: 'GET', params }),
            providesTags: ['UsageStatistics']
        }),

        getPerformanceStatistics: build.query({
            query: (params) => ({ url: '/stats/performance/', method: 'GET', params }),
            providesTags: ['UsageStatistics']
        }),

        getUserAnalytics: build.query({
            query: (params = {}) => ({ 
                url: '/analytics/user/', 
                method: 'GET', 
                params 
            }),
            providesTags: ['Analytics']
        }),

        getAdminAnalytics: build.query({
            query: (params = {}) => ({ 
                url: '/analytics/admin/', 
                method: 'GET', 
                params 
            }),
            providesTags: ['Analytics']
        }),

        getAnalyticsSummary: build.query({
            query: () => ({ url: '/analytics/summary/', method: 'GET' }),
            providesTags: ['Analytics']
        }),
    })
});

export const { 
    useTrackPageViewMutation,
    useTrackFeatureUsageMutation, 
    useTrackSearchQueryMutation,
    useGetUsageStatisticsQuery,
    useGetPerformanceStatisticsQuery,
    useGetUserAnalyticsQuery,
    useGetAdminAnalyticsQuery,
    useGetAnalyticsSummaryQuery
} = usageStatisticsApi;